import { Link } from 'react-router-dom';
import GraphicPackingConst from '../graphic-packing-const';


const GraphicPackingViewField = ({ id, count, model }) => {

    return (
        <div className='view-box-field'>
            { count ?
                <Link
                    to={ `${ GraphicPackingConst.basePath }/${ id }/${ model }` }
                >
                    <span className='count'>{ count }</span>
                    <span className='btn-view'>view</span>
                </Link> : <strong>&mdash;</strong> }
        </div>

    );
};

export default GraphicPackingViewField;